let maptilesKey = '';

/** Configure only the display map. Geocoding and routing remain separate. */
export function configureGoongMaptilesKey(key: string): void {
  maptilesKey = key.trim();
}

export function getGoongMaptilesKey(): string {
  return maptilesKey;
}

export function goongMapStyleUrl(key: string): string {
  const url = new URL('https://tiles.goong.io/assets/goong_map_web.json');
  url.searchParams.set('api_key', key);
  return url.toString();
}
